import { GameObjects, Scene } from "phaser";
import { Background } from "../background/Background";
import { GameVars } from "../../GameVars";
import { Button } from "../../utils/Button";
import { AudioManager } from "../../managers/AudioManager";
import { GameConstants } from "../../GameConstants";
import { CheckButton } from "./CheckButton";
import { GameManager } from "../../managers/GameManager";
import { Translation } from "../../Translation";

export class LanguageSelectionLayer extends GameObjects.Container {
    private _langChanged: boolean;
    private _buttons: CheckButton[];
    private _okButtonLabel: GameObjects.Text;
    constructor(scene: Scene, x: number, y: number) {
        super(scene, x, y);
        this._langChanged = false;
        this._buttons = [];
        const background = new Background(this.scene);
        this.add(background);

        let backButton = new Button(this.scene, 35 * GameVars.scaleX, 35, "texture_atlas_1", "btn_menu.png", "btn_menu.png", true, true);
        backButton.scaleX = GameVars.scaleX;
        backButton.onUp(this.onClickBack, this);
        this.add(backButton);

        const langs = [
            GameConstants.LANG_CA,
            GameConstants.LANG_DE,
            GameConstants.LANG_EN,
            GameConstants.LANG_ES,
            GameConstants.LANG_FR,
            GameConstants.LANG_IT,
            GameConstants.LANG_PT,
        ];

        const bg = new GameObjects.Rectangle(this.scene, 0, 0, 200, 300, 0, 0.3);
        this.add(bg);
        bg.x = GameConstants.GAME_WIDTH / 2;
        bg.y = GameConstants.GAME_HEIGHT / 2;

        for (let i = 0; i < langs.length; i++) {
            const lang = langs[i];
            const b = new CheckButton(this.scene, bg.getTopLeft().x + 20, 15 + bg.getTopLeft().y + i * 40, lang, GameVars.gameData.language === lang);
            this.add(b);
            this._buttons.push(b);
            b.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, () => {
                this._buttons.forEach(bb => {
                    bb.select(false);
                });
                b.select(true);
                GameVars.gameData.language = lang;
                this._langChanged = true;
                this._okButtonLabel.setText(Translation.getText("OK"))
                GameManager.writeGameData();
            }, this);
        }

        const okButtonContainer = new Phaser.GameObjects.Container(this.scene, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2 + 200);
        this.add(okButtonContainer);

        const okButton = new Button(this.scene, 0, 0, "texture_atlas_1", "btn_yellow_wide.png", "btn_yellow_wide.png", true);
        okButton.onUp(this.onClickBack, this);
        okButtonContainer.add(okButton);

        this._okButtonLabel = new Phaser.GameObjects.Text(this.scene, 0, 0, Translation.getText("OK"), { fontFamily: "Oswald-Medium", fontSize: "22px", color: "#622F20", align: "center" });
        this._okButtonLabel.setOrigin(.5);
        okButtonContainer.add(this._okButtonLabel);

        const logoText = new Phaser.GameObjects.Text(this.scene, GameConstants.GAME_WIDTH / 2 - 20, GameConstants.GAME_HEIGHT - 30, "Amb el suport de la Generalitat de Catalunya", { fontFamily: "Oswald-Medium", fontSize: "22px", color: "#ffffff", align: "center" });
        logoText.setOrigin(0.5)
        this.add(logoText);

        const logo = new GameObjects.Image(this.scene, logoText.getRightCenter().x + 20, logoText.y, "ca_logo");
        logo.setScale(0.7);
        this.add(logo);
    }

    private onClickBack(): void {

        AudioManager.playSound("btn_click");
        this.visible = false;
        if (this._langChanged) {
            this.scene.scene.restart();
        }
    }
}